import type { RequestForQuotationSupplierLookup } from '../types/request-for-quotation-supplier-lookup.type';
import type { RequestForQuotationSupplierResponse } from '../types/request-for-quotation-supplier-response.type';
import { PaginatedResponseModel } from './paginated-response.model';
import { RequestForQuotationSupplierLookupModel } from './request-for-quotation-supplier-lookup.model';

export class RequestForQuotationSupplierResponseModel
  extends PaginatedResponseModel
  implements RequestForQuotationSupplierResponse
{
  readonly items: RequestForQuotationSupplierLookup[];

  constructor(data: RequestForQuotationSupplierResponse) {
    super(data);

    this.items = data.items.map(
      (item) => new RequestForQuotationSupplierLookupModel(item),
    );
  }
}
